// Helpers y constantes de filtros para el listado de devoluciones (desktop + móvil).
import { getUserWarehouse } from '../../auth/sessionRbac'
import { REFUND_FILTER_KEYS } from './refundMobileFilters'
import {
  FILTER_DIMENSIONS,
  createEmptyFilterOptionsState
} from './refundFilterOptions'

export const FILTER_SEARCH_MIN_CHARS = 3

export const ASYNC_FILTER_KEYS = [
  REFUND_FILTER_KEYS.CLIENT,
  REFUND_FILTER_KEYS.USER,
  REFUND_FILTER_KEYS.WAREHOUSE
]

export const FILTER_KEY_TO_DIMENSION = {
  [REFUND_FILTER_KEYS.CLIENT]: FILTER_DIMENSIONS.CLIENT,
  [REFUND_FILTER_KEYS.USER]: FILTER_DIMENSIONS.SALESMAN,
  [REFUND_FILTER_KEYS.WAREHOUSE]: FILTER_DIMENSIONS.WAREHOUSE
}

export const createInitialFilterOptionsByKey = () => ({
  [REFUND_FILTER_KEYS.CLIENT]: createEmptyFilterOptionsState(),
  [REFUND_FILTER_KEYS.USER]: createEmptyFilterOptionsState(),
  [REFUND_FILTER_KEYS.WAREHOUSE]: createEmptyFilterOptionsState()
})

/** Bodega fija del procesador; estados no van preseleccionados (el backend aplica defaults). */
export const createProcesadorDefaultSelections = () => {
  const selections = new Map()
  const warehouse = getUserWarehouse()

  if (warehouse?.uid) {
    selections.set(REFUND_FILTER_KEYS.WAREHOUSE, [warehouse.uid])
  }

  return selections
}

export const isLockedWarehouseFilterKey = (warehouseLocked, filterKey) =>
  Boolean(warehouseLocked && filterKey === REFUND_FILTER_KEYS.WAREHOUSE)

export const buildFiltersQuery = (selectedOptions) => {
  let queryParam = ''

  selectedOptions.forEach((value, key) => {
    if (value.length === 0) return

    if (key === REFUND_FILTER_KEYS.CLIENT) {
      queryParam += `&client_uid=${value.join(',')}`
    } else if (key === REFUND_FILTER_KEYS.USER) {
      queryParam += `&salesman_uid=${value.join(',')}`
    } else if (key === REFUND_FILTER_KEYS.STATUS) {
      queryParam += `&status=${value.join(',')}`
    } else if (key === REFUND_FILTER_KEYS.WAREHOUSE) {
      queryParam += `&warehouse_uid=${value.join(',')}`
    }
  })

  return queryParam
}

export const getFormattedRefundDate = (createdDate) => {
  const d = new Date(createdDate)
  return d.toLocaleString()
}

export const openRefundInNewTab = (uuid) => {
  window.open(`/devoluciones/${uuid}`, '_blank')
}

export const showRefundModel = (event, refundUuid) => {
  event.preventDefault()
  window.open(`/devoluciones/${refundUuid}`, '_blank')
}
